/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Pipe, PipeTransform} from '@angular/core';

import {formatAdnNumber} from './format-adn-number';
import {AppLocaleService} from '../locale/app-locale.service';

@Pipe({standalone: false, name: 'adnNumber'})
export class AdnNumberPipe implements PipeTransform {
  constructor(private readonly appLocale: AppLocaleService) {
  }

  transform(stat: any): number | string {
    return formatAdnNumber(stat, this.appLocale.getLocaleId());
  }
}
